import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const Triads = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getTriadQuestions: builder.query({
            query: () => {
                return {
                    url: constants.GET_TRIAD_QUESTIONS,
                };
            },
            providesTags: ['triad'],
        }),
        getTriadQuestionsByVersion: builder.query({
            query: (triadVersionId: number) => {
                return {
                    url: constants.GET_TRIAD_QUESTIONS_BY_VERSION,
                    params: { triadVersionId },
                };
            },
            providesTags: ['triad'],
        }),
        getTriadScores: builder.query({
            query: () => {
                return {
                    url: constants.GET_TRIAD_SCORE,
                };
            },
            providesTags: ['triad'],
        }),
        createTriadResponse: builder.mutation({
            query: (data: any) => {
                return {
                    url: constants.CREATE_TRIAD_RESPONSE,
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['triad'],
        }),
        getTriadResponse: builder.query({
            query: (data: any) => {
                return {
                    url: constants.TRIAD_RESPONSE,
                    method: 'GET',
                    params: data,
                };
            },
            providesTags: ['triad'],
        }),
        createTriad: builder.mutation({
            query: (data: any) => ({
                url: constants.CREATE_TRIAD,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['triad'],
        }),
        updateTriad: builder.mutation({
            query: (data: any) => ({
                url: constants.UPDATE_TRIAD_RESPONSE,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['triad'],
        }),
        getTriad: builder.query({
            query: (data: any) => {
                return {
                    url: constants.GET_TRIAD,
                    method: 'GET',
                    params: data,
                };
            },
            providesTags: ['triad'],
        }),
        getTriadInfo: builder.query({
            query: (data: any) => {
                return {
                    url: constants.GET_TRIAD_INFO,
                    method: 'GET',
                    params: data,
                };
            },
            providesTags: ['triad', 'Coaching'],
        }),
        getTriadTlGraphicHistory: builder.query({
            query: (data: any) => {
                return {
                    url: constants.GET_TRIAD_TL_GRAPHIC_HISTORY,
                    method: 'GET',
                    params: data,
                };
            },
            providesTags: ['triad'],
        }),
        getTriadCapabilityBucket: builder.query({
            query: () => {
                return {
                    url: constants.GET_TRIAD_CAPABILITY_BUCKET,
                    method: 'GET',
                };
            },
            providesTags: ['triad'],
        }),
    }),
});

export const {
    useGetTriadQuestionsQuery,
    useGetTriadQuestionsByVersionQuery,
    useGetTriadScoresQuery,
    useCreateTriadMutation,
    useUpdateTriadMutation,
    useCreateTriadResponseMutation,
    useGetTriadResponseQuery,
    useGetTriadQuery,
    useGetTriadInfoQuery,
    useGetTriadTlGraphicHistoryQuery,
    useGetTriadCapabilityBucketQuery,
} = Triads;